import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Dashboard/Navbar";
import Sidebar from "../Dashboard/Sidebar";
import Footer from "../Footer";
function SupportDashboard() {
  const SidebarList = [
    {
      category: "Dashboard",
      route: "",
    },
    {
      category: "View Publisher",
      subcategory: [
        { name: "Active", route: "publisher/active" },
        { name: "Inactive", route: "publisher/inactive" },
      ],
    },
    {
      category: "View Marketer",
      subcategory: [
        { name: "Active", route: "marketer/active" },
        { name: "Inactive", route: "marketer/inactive" },
      ],
    },
    {
      category: "Customer Support",
      subcategory: [
        { name: "Marketer Reset Password", route: "cust-sup/marresetpassword" },
        {
          name: "Publisher Reset Password",
          route: "cust-sup/pubresetpassword",
        },
        { name: "Answer Ticket", route: "cust-sup/answerticket" },
      ],
    },
  ];

  const navMenu = [
    {
      link: "/",
      text: "Logout",
    },
  ];

  return (
    <>
      <Navbar navMenu={navMenu} />

      <div className="container-fluid">
        <div className="row h-90 ">
          <div className="col-2  shadow shadow-md">
            <Sidebar list={SidebarList} />
          </div>
          <div className="col-10">
            <Outlet />{" "}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default SupportDashboard;
